<template>
  <el-popover
    :ref="'filter-pop'"
    popper-class="filter-pop"
    placement="right-start"
    :width="400"
    :offset="-25"
    trigger="click"
    @show="onPopShow"
  >
    <div class="header-label" slot="reference">
      <el-button class="orange-btn" size="small">批量搜索</el-button>
    </div>
    <div class="filter-panel">
      <div style="text-decoration: none;margin-bottom: 5px">请按照型号 品类格式粘贴</div>
      <div class="serachBOx">
        <div>
          <el-input
            type="textarea"
            :rows="14"
            v-model="textareaValue"
            @input="textareaValue = textareaValue.replace(/\t/g, ' ')"
          ></el-input>
        </div>
        <div>
          <div class="textareaBox">
            <div v-for="(item, index) in this.spanList" :key="index">
              <span
                :class="`${spanIndex.includes(index) ? 'text_color' : ''}`"
                >{{ item }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="filter-panel-btn-wrap">
        <el-button size="mini" @click="resetFilter">清空</el-button>
        <el-button size="mini" type="primary" @click="closePop">关闭</el-button>
        <el-button
          size="mini"
          class="orange-btn"
          @click="seachFilter"
          >搜索</el-button
        >
      </div>
      <div v-if="textareabox" class="spanFooter">
        <div>检测到{{ textList.length }}个型号</div>
        <div>
          <span>已匹配{{ Matched }}个型号</span>
          <span>未匹配{{ unmatched }}个型号</span>
        </div>
      </div>
    </div>
  </el-popover>
</template>

<script>
import Emitter from "@/utils/emitter-mixin";
export default {
  name: "searchBatch",
  mixins: [Emitter],
  props: ["searchForm"],
  watch: {},
  data() {
    return {
      textareaValue: "",
      textareabox: false,
      textList: "", //value值解析
      spanIndex: [], //未匹配下标
      Matched: 0, //已匹配
      unmatched: 0, //未匹配
      spanList: "", //排序
      empty: false, //是否清空,
    };
  },
  methods: {
    //处理文本域换行方法
    preText(pretext) {
      return pretext
        .replace(/\r\n/g, ",")
        .replace(/\n/g, ",")
        .replace(/\s/g, "&nbsp;");
    },
    onPopShow() {
      //  this.$emit('textareaData')
    },
    // hide() {
    //   this.textareaValue = ""
    //   this.textareabox = false
    // },
    resetFilter() {
      this.textareaValue = "";
      this.spanIndex = [];
      this.spanList = [];
      this.textList = [];
      this.Matched = 0;
      this.unmatched = 0;
      this.textareabox = false;
    },
    seachFilter() {
      this.spanIndex = []
      this.textList = this.textareaValue.split("\n").filter((v) => v);
      let data = {
        typeCategoryList: this.textList,
        // storeCode: this.searchForm.storeCode,
        pageSize: 99999,
        pageNum: 1,
      };
      this.$q.shortVideoOverview.videoBatchQuery({ data: data }).then((res) => {
        console.log(res.data);
        this.unmatched = res.data.errorList.length; //未匹配
        this.Matched = res.data.validList.length; //已匹配
        this.textareabox = true; //隐藏搜索按钮
        this.spanList = this.textList;
        this.textList.forEach((item, index) => {
          if(res.data.errorList.includes(item)){
            this.spanIndex.push(index);
          }
          
        });
        this.$emit("seachFilter", this.textList);
      });
    },

    closePop() {
      const popRef = this.$refs["filter-pop"];
      if (popRef) {
        popRef.doClose();
      }
    },

    created() {},
  },
};
</script>
<style  scoped>
.active_header {
  color: #e67b00;
}
.spanFooter div:first-child {
  padding-bottom: 10px;
  font-size: 13px;
}
.spanFooter div:last-child {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.text_color {
  color: #d9001b;
}
</style>
<style lang="stylus" scoped>
.header-label {
  display: inline-flex;
  align-items: center;
  line-height: 23px;
  width: auto;
  height: auto;
  cursor: pointer;
  padding: 0;
  margin-left: 15px;
  display: inline-block;
}

.filter-panel span {
  font-size: 13px;
  display: inline-block;
}

.filter-pop {
  padding: 10px 5px;
}

.filter-panel {
  .filter-input {
    >>> .el-input-group__append {
      padding: 0 10px;
    }
  }

  &-sort-wrap {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 10px;
  }

  &-number-wrap {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    >span {
      flex: none;
      width: 65px;
    }

    .number-select {
      width: 120px;
    }

    .number-input {
      margin-left: 5px;
      width: 80px;

      >>> .el-input__inner {
        padding: 0 5px;
      }
    }
  }

  &-select-wrap {
    box-sizing: border-box;
    padding: 5px;
    margin-top: 10px;
    width: 100%;
    // height 200px
    border: 1px solid #DCDFE6;

    // overflow auto
    .virtual-list {
      width: 100%;
      height: 200px;
      overflow: auto;
    }

    .condition-item {
      display: block;
    }
  }

  &-btn-wrap {
    margin-top: 10px;
    text-align: right;
  }
}

.active {
  color: #fff;
  background-color: #0BB78E;
  border-color: #0BB78E;
}

.filter-panel-btn-wrap {
  height: 40px;
}

.serachBOx {
  display: flex
}

.textareaBox {
  margin-left: 20px
  height: 294px;
  width: 159px
  padding: 5px 15px;
  border: 1px solid #DCDFE6;
  color: #606266;
  border-radius: 4px;
  line-height: 21px;
  font-size: 14px;
  text-rendering: auto;
  text-transform: none;
  text-indent: 0px;
  text-shadow: none;
  text-align: start;
  appearance: auto;
  flex-direction: column;
  cursor: text;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  overflow-x: auto;
}

.textareaBox span {
  font-size: 14px;
}

>>> .el-textarea__inner {
  resize: none;
}
</style>